/** When true, TNE packages include the transfer funnel step. Disabled until TNE transfer is ready. */
export const ENABLE_TNE_TRANSFER = false;

/** When true, show the ski station dropdown on the transfer page (TNE packages only). */
export const ENABLE_TNE_STATION_DROPDOWN = false;
